export const SHOW_SUCCESS_MESSAGE = 'SHOW_SUCCESS_MESSAGE';
export const SHOW_ERROR_MESSAGE = 'SHOW_ERROR_MESSAGE';
export const SHOW_WARNING_MESSAGE = 'SHOW_WARN_MESSAGE';
export const ON_NOTIFICATION_RESET = 'ON_NOTIFICATION_RESET';
export const ADD_LOADER = 'ADD_LOADER';
export const REMOVE_LOADER = 'REMOVE_LOADER';
